<template>
    <div id="mask" v-show="show">
        <div id="contain">
            <div class="exam-div"
                v-for="(exam, index) in exams.slice((pageIndex * pageShowLimit), ((pageIndex + 1) * pageShowLimit))"
                :key="exam" :id="'exam_' + index" @click="openViewer(exam)">
                <img crossorigin="Anonymous" :src="`${getQuestionPath()}${path}/${exam + 'q'}.png`" class="quest-img">
                <img class="enlarge-icon" src="../../assets/art/exam/enlarge.svg">
            </div>
        </div>
        <div id="toolbar">
            <span id="tool-title" class="tools">隨堂測驗</span>
            <label id="radio-5" class="tools radio-label">
                <input class="radio" type="radio" value="5" v-model='count'>五題
            </label>
            <label id="radio-10" class="tools radio-label">
                <input class="radio" type="radio" value="10" v-model='count'>十題
            </label>
            <div id="reload-exam" class="tools button" @click="setQuestionCount()"> 重新出題 </div>
            <div id="previous-page" class="tools button" @click="previousPage()"> 上一頁 </div>
            <div id="next-page" class="tools button" @click="nextPage()"> 下一頁 </div>

            <img id="close-icon" src="../../assets/art/exam/close.svg" @click="close()">
        </div>
    </div>
</template>

<script>

import BookData from '@/js/book_data';
import { examStore } from '@/js/store/examStore';
import EventBus from '@/js/event_bus';

export default {
    name: "LessonExam",
    data: function () {
        return {
            show: false,
            path: "",
            count: 10,
            pageShowLimit: 6,
            pageIndex: 0,
            exams: [],
        }
    },
    methods: {
        close() {
            this.show = false;
        },
        setExamPath() {
            this.path = examStore.getExamData().path;
        },
        setRandomExam() {
            this.pageIndex = 0;
            this.exams = examStore.getRandomExam();
        },
        getQuestionPath: function () {
            return BookData.Instance.getQuestionPath();
        },
        setQuestionCount() {
            examStore.randomCount = this.count;
            this.setRandomExam();
        },
        previousPage() {
            if (this.exams.length < (this.pageIndex + 1) * this.pageShowLimit) {
                if (this.pageIndex > 0) {
                    this.pageIndex--;
                }
            }
        },
        nextPage() {
            if (this.exams.length > (this.pageIndex + 1) * this.pageShowLimit) {
                this.pageIndex++;
            }
        },
        openViewer(exam) {
            EventBus.getInstance().getAppRefs().lessonExamViewer.showExam(
                `${this.getQuestionPath()}${this.path}`, exam
            );
        }
    }
}
</script>

<style scoped>
#mask {
    z-index: var(--z-index-lesson-exam);
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgb(19, 43, 106);
}

#contain {
    position: absolute;
    width: 100%;
    height: 90%;
    transform-origin: top;
    background-color: rgb(19, 43, 106);
    transform: scale(var(--window-scale));
    display: grid;
    grid-template-columns: 600px 600px;
    grid-template-rows: 300px 300px 300px;
    justify-content: center;
    align-items: center;
    grid-column-gap: 8px;
    grid-row-gap: 7px;
}

#toolbar {
    position: absolute;
    width: 100% !important;
    min-width: calc(100% / var(--window-scale));
    height: 10%;
    bottom: 0%;
    background-color: white;
    transform: scale(var(--window-scale));
    transform-origin: bottom left;
    left: 0px;
}

.tools {
    position: absolute;
}

.radio-label {
    font-size: 30px;
    line-height: 10vh;
}

.radio-label input {
    margin-right: 15px;
}

.radio {
    width: 20px;
    height: 20px;
}

#tool-title {
    font-size: 30px;
    line-height: 10vh;
    left: 20px;
}

#radio-5 {
    left: 170px;
}

#radio-10 {
    left: 300px;
}

.button {
    width: 160px;
    height: 40px;
    background-color: rgb(27, 106, 187);
    top: 50%;
    transform: translateY(-50%);
    line-height: 40px;
    font-size: 30px;
    border-radius: 5px;
    color: white;
}

#reload-exam {
    left: 420px;
}

#previous-page {
    left: 600px;
}

#next-page {
    left: 780px;
}

#close {
    position: absolute;
    width: 17px;
}

.exam-div {
    position: relative;
    width: 600px;
    height: 300px;
    background-color: white;
}

.quest-img {
    width: 600px;
    position: absolute;
    clip: rect(0px 600px 300px 0px);
    left: 0px;
}

.enlarge-icon {
    position: absolute;
    right: 4px;
    bottom: 0;
}

#close-icon {
    position: absolute;
    transform: translate(-50%, -50%);
    right: 60px;
    top: 50%;
    height: 35px;
}
</style>